const { requiredDocumentStatus } = require('../views/Admin/requiredDocumentStatus');

const requiredDocuments = {
  'Bewacher-PDF': {
    field: 'bewacherpdf',
    manualValidUntilField: null
  },
  Personalausweis: {
    field: 'personalausweis',
    manualValidUntilField: 'personalausweisManualValidUntil'
  },
  Aufenthaltsnachweis: {
    field: 'aufenthaltsnachweis',
    manualValidUntilField: 'aufenthaltsnachweisManualValidUntil'
  },
  'SV-Nachweis': {
    field: 'svNachweis',
    manualValidUntilField: null
  }
};

function requiredSubcategories(employee, creditor) {
  if (employee.is_external) {
    if (!creditor) return null;
    return [
      creditor.requiresPersonalausweis && 'Personalausweis',
      creditor.requiresSvNachweis && 'SV-Nachweis',
      creditor.requiresAufenthaltserlaubnis && 'Aufenthaltsnachweis'
    ].filter(Boolean);
  }
  return ['Bewacher-PDF'];
}

function isEmployeeEinsatzfaehig({ employee, creditor, files = [], today }) {
  const required = requiredSubcategories(employee, creditor);
  if (required === null) return false;

  return required.every(subcategory => {
    const requirement = requiredDocuments[subcategory];
    const matchingFiles = files.filter(file =>
      file.category === 'Qualifikation' &&
      file.subcategory === subcategory &&
      file.archived !== true
    );
    const status = requiredDocumentStatus({
      subcategory,
      files: matchingFiles,
      germanNational: employee.germanNational === true,
      confirmed: employee[requirement.field] === true,
      manualValidUntil: requirement.manualValidUntilField
        ? employee[requirement.manualValidUntilField]
        : null,
      today
    });
    return status === 'Hochgeladen' ||
      status === 'Manuell bestätigt' ||
      status === 'nicht erforderlich';
  });
}

module.exports = {
  isEmployeeEinsatzfaehig,
  requiredSubcategories
};
